import { styled } from "@mui/material/styles";
import { Box, Button, Typography } from "@mui/material";

export const RootContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: theme.palette.background.default,
  paddingLeft: "30px",
  paddingRight: "30px",
  borderRadius: "10px",
  position: "relative",
  paddingTop: "56px",
  paddingBottom: "56px",
  border: `2px solid ${theme.palette.background.paper}`,
  [theme.breakpoints.down("xl")]: {
    padding: "20px",
    width: "80vw",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "20px",
    width: "90vw",
  },
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "20px",
  [theme.breakpoints.down(1600)]: {
    flexDirection: "row",
  },
}));

export const Divider = styled(Box)(({ theme }) => ({
  borderTop: `1px dashed ${theme.palette.divider}`,
  width: "100%",
  marginTop: "24px",
  marginBottom: "24px",
}));

export const UploadButtonsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  alignItems: "start",
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    width: "100%",
    alignItems: "stretch",
    justifyContent: "stretch",
  },
}));

export const UploadButton = styled(Button)(({ theme }) => ({
  whiteSpace: "nowrap",
  border: `1px dashed ${theme.palette.divider}`,
  color: "white",
}));

export const CancelButtonLabel = styled(Typography)(() => ({
  borderBottom: "1px solid",
}));

export const UploadButtonLabel = styled(Typography)(({ theme }) => ({
  maxWidth: "150px",
  textOverflow: "ellipsis",
  overflow: "hidden",
  color: theme.palette.text.primary,
}));

export const Title = styled(Typography)(({ theme }) => ({
  textAlign: "left",
  [theme.breakpoints.down(1600)]: {
    textAlign: "center",
  },
}));

export const SuccessMessageCloseButton = styled(Button)(() => ({
  borderRadius: "100%",
  aspectRatio: "1/1",
  position: "absolute",
  top: 4,
  right: 4,
  minWidth: "0",
  padding: "0 3px",
  display: "flex",
  span: {
    width: "0",
  },
}));

export const SuccessMessageTitle = styled(Typography)(({ theme }) => ({
  fontSize: "32px",
  fontWeight: 700,
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    fontSize: "24px",
  },
}));

export const SuccessMessageDescription = styled(Typography)(() => ({
  fontSize: "16px",
}));

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  marginTop: "30px",
  textAlign: "left",
  width: "100%",
  [theme.breakpoints.down(1600)]: {
    textAlign: "center",
  },
}));
